export const clusterApi = {
  createCluster: '/clouddm/console/api/v1/cluster/create',
  deleteCluster: '/clouddm/console/api/v1/cluster/delete',
  getClusterList: '/clouddm/console/api/v1/cluster/listbycondition',
  listDsBindCluster: '/clouddm/console/api/v1/datasource/listDsBindCluster',
  updateClusterDesc: '/clouddm/console/api/v1/cluster/updateclusterdesc',
  getCluster: '/clouddm/console/api/v1/cluster/querybyid'
};
